<template>
  <div :class="{ webwallet: account && nftAccount }">
    <web-nav />
    <login v-if="!account" />
    <nftLogin v-else-if="!nftAccount" />
    <template v-else-if="account">
      <side-bar />
      <section class="main-info">
        <div class="main-container">
          <div class="tabs">
            <router-link class="tab" :to="`../assets?addr=${nftAccount}`" append>
              {{ $t("assets") }}
            </router-link>
            <router-link class="tab" :to="`../collectibles?addr=${nftAccount}`" append>
              {{ $t("collectibles") }}
            </router-link>
          </div>
          <router-view class="transfer-container"></router-view>
        </div>
      </section>
    </template>
  </div>
</template>
<script>
import webNav from "base/nav";
import login from "base/login";
import nftLogin from "base/nftLogin";
import sideBar from "base/sidebar";
export default {
  components: {
    sideBar,
    login,
    nftLogin,
    webNav,
  },
};
</script>
